<div class="photo-grid">
  <div class="grid-content" dragula="PHOTOS" [dragulaModel]="paginatedPhotos" (dragulaModelChange)="onReorder($event)">
    <app-photo-card
      *ngFor="let photo of paginatedPhotos"
      [photo]="photo"
      [propertyId]="propertyId"
      [isSelected]="isPhotoSelected(photo.photo_id)"
      [showSelection]="showSelection"
      [showDelete]="showDelete"
      [showSetMain]="showSetMain"
      [showTags]="showTags"
      [availableTags]="availableTags"
      (select)="onSelect($event)"
      (delete)="onDelete($event)"
      (setMain)="onSetMain($event)"
    ></app-photo-card>
  </div>
  <mat-paginator2
    #paginator
    [length]="photos.length"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPageChange($event)"
    class="mt-3"
  >
  </mat-paginator2>
</div>
